import type { CodeProps } from 'react-markdown/lib/ast-to-react';

export function Code({ inline, className, children, ...props }: CodeProps) {
  const match = /language-(\w+)/.exec(className ?? '');

  return !inline && match ? (
    <code {...props}>{String(children).replace(/\n$/, '')}</code>
  ) : (
    <code className={className} {...props}>
      {children}
    </code>
  );
}
